import React from 'react'
import * as Bs from 'react-bootstrap'

/**
 * Filter data table component
 */
class Filter extends React.Component {
  static propTypes = {
    route: React.PropTypes.string,
    search: React.PropTypes.string,
    offset: React.PropTypes.number,
    sort: React.PropTypes.string,
    dir: React.PropTypes.string
  }

  static contextTypes = {
    router: React.PropTypes.func
  }

  constructor (props, context) {
    super(props, context)
    this.state = { filter: props.search }
  }

  handleSearch (evt) {
    const isEnter = evt.keyCode === 13

    if (isEnter) {
      this.context.router.replaceWith(this.props.route, null, {
        search: evt.target.value || undefined,
        sort: this.props.sort,
        dir: this.props.dir
      })
    }
  }

  _handleChange (evt) {
    this.setState({ filter: evt.target.value })
  }

  resetSearch (evt) {
    this.setState({ filter: '' })
    this.context.router.replaceWith(this.props.route, null, {
      search: undefined,
      sort: this.props.sort,
      dir: this.props.dir
    })
  }

  render() {
    const resetButton = (
      <Bs.Button
        className="hotkeys-clear"
        onClick={::this.resetSearch}>
        Reset
      </Bs.Button>
    )

    return (
      <Bs.Input
        type="text"
        className="hotkeys-search"
        onKeyUp={::this.handleSearch}
        onChange={::this._handleChange}
        value={this.state.filter}
        placeholder="Filter results (return to search)"
        buttonAfter={resetButton} />
    )
  }
}

export default Filter



// WEBPACK FOOTER //
// ./modules/shared/components/filter.js